import crypto from "crypto-js";

export const BASE64_PAYLOAD_PREFIX = "base64:";

export const encodeBase64Payload = (
  value?: string | null
): string | undefined =>
  value
    ? `${BASE64_PAYLOAD_PREFIX}${crypto.enc.Base64.stringify(
        crypto.enc.Utf8.parse(value)
      )}`
    : undefined;
